
import { Component, Mixins, Ref } from 'vue-property-decorator'
import MixinInterface from '@/_mixins/index'

import PasswordInput from '@/_components/input/password/password.vue'
import { deserialise, serialise } from 'kitsu-core'
import Verify from '@/views/Authentication/dialog/verify/verify.vue'
import { patchRequest, getRequest, postRequest, deleteRequest } from '@/plugins/api-axios'
import { User } from '@/views/Authentication/types/user'
import { Session } from '@/views/Authentication/types/session'

@Component({
    components: { PasswordInput },
    mixins: [],
})
export default class PasswordSettings extends Mixins<MixinInterface>() {
    @Ref('form') readonly form!: HTMLFormElement
    user: null | User = null

    async mounted() {
        await this.getUser()
    }

    async getUser() {
        let res = await getRequest(
            this.getURL({
                path: `users/${this.currentUser.id}`,
                params: {
                    include: 'sessions',
                },
                base: this.authenticationBaseUrl,
            }),
            this.headersmixins
        )

        if (res) {
            this.user = deserialise(res.data).data
        }
    }

    valid = false
    loading = false
    password = ''
    rePassword = ''
    rePasswordVisible = false
    successful = false

    get rePasswordRule() {
        return () =>
            this.password === this.rePassword ||
            this.getTranslation('fe_authentication.error_password_matched')
    }

    async updatePassword(useMfa = false) {
        this.loading = true
        if (this.valid && this.password && this.rePassword) {
            let payload = serialise(this.currentUser.type, {
                id: this.currentUser.id,
                password: this.password,
            })

            let res = await patchRequest(
                `${this.authenticationBaseUrl}/users/${this.currentUser.id}`,
                {
                    ...this.headersmixins,
                    ...(useMfa && { UseMfa: true }),
                },
                payload.data
            ).catch(async (error) => {
                this.$store.commit('closeSnackbar')
                if (error.data.response.data.errors[0].code == 'proofRequired') {
                    let confirm = await this.openDialog(Verify, {
                        claim: error.data.response.headers['mfa-proof-claim'],
                        type: 'verify',
                    })
                    if (confirm) {
                        return await this.updatePassword(useMfa)
                    }
                }
            })

            if (res) {
                this.password = ''
                this.rePassword = ''
                this.form.reset()
                this.successful = true
            }
        }
        this.loading = false
    }

    loadingDeleteSessions = false
    async deleteOtherSessions() {
        this.loadingDeleteSessions = true
        let res = await postRequest(
            this.getURL({
                path: `users/${this.currentUser.id}/deleteOtherSessions`,
                params: {
                    include: 'sessions',
                },
                base: this.authenticationBaseUrl,
            }),
            this.headersmixins
        )

        if (res) {
            this.user = deserialise(res.data).data
        }
        this.loadingDeleteSessions = false
    }

    revokinSession: null | string = null
    async revokeSession(session: Session) {
        this.revokinSession = session.id
        let res = await deleteRequest(session.links.self, this.headersmixins)

        if (res) {
            await this.getUser()
        }
        this.revokinSession = null
    }
}
